import { render, staticRenderFns } from "./genelarama.vue?vue&type=template&id=8f496e44&"
import script from "./genelarama.vue?vue&type=script&lang=js&"
export * from "./genelarama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports